import React from 'react';
import { Menu } from '@headlessui/react';

import type { User } from 'state/__generated__/tadaahAPI';

import Avatar from 'components-new/avatar/avatar';
import Typography from 'components-new/typography/typography';

import AvatarMenuItem from './avatar-menu-item';
import type { AvatarMenuItemType } from './avatar-menu-item';
import AvatarMenuView from './avatar-menu-view';
import type { AvatarMenuViewType } from './avatar-menu-view';

export interface AvatarMenuProps {
  user: User | undefined;
  menuItems: AvatarMenuItemType[];
  views: AvatarMenuViewType[];
}

const AvatarMenu: React.FC<AvatarMenuProps> = ({ user, views, menuItems }) => {
  return (
    <div className="relative">
      <Menu as="div" className="relative inline-block text-left">
        <Menu.Button as={React.Fragment}>
          <Avatar
            image={user?.picture}
            name={user?.first_name}
            className="border-gray-200 ui-open:border-primary"
          />
        </Menu.Button>
        <Menu.Items className="origin-top-right absolute right-0 mt-2 p-1 w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none">
          <div className="py-1">
            <Typography
              variant="body-medium-bold"
              as="span"
              className="block px-4 py-1 text-sm text-gray-700"
            >
              {user?.first_name} {user?.last_name}
            </Typography>
            <Typography
              variant="body-medium"
              as="span"
              className="block px-4 py-1 text-xs text-gray-800"
            >
              {user?.email}
            </Typography>
          </div>
          <div className="border-t border-gray-100" />
          <div className="py-1">
            {views.map((view) => (
              <AvatarMenuView key={view.name} view={view} />
            ))}
          </div>
          <div className="border-t border-gray-100" />
          <div className="py-1">
            {menuItems.map((menuItem) => (
              <AvatarMenuItem key={menuItem.name} menuItem={menuItem} />
            ))}
          </div>
        </Menu.Items>
      </Menu>
    </div>
  );
};

export default AvatarMenu;
